/*
 * @Author: your name
 * @Date: 2021-06-24 15:15:18
 * @LastEditTime: 2021-11-25 17:47:23
 * @LastEditors: Please set LastEditors
 * @Description: 解决物理返回键，组件页面正常返回
 * @FilePath: \main\src\mixins\componentPushMixins.js
 */

export default {
  data() {
    return {
      curRecdPage: 0
      // stopWatchRoute: false
    }
  },
  watch: {
    $route(to, from) {
      // if (this.stopWatchRoute) return
      console.log('from :', from.query, 'to:', to.query)
      let {query: fromQuery, name: fromName} = from
      let {query: toQuery, name: toName} = to
      if (fromName != toName) return //仅监听相同路由名的切换，路由名不相同不处理
      let {_recdPage: from_recdPage} = fromQuery
      let {_recdPage: to_recdPage} = toQuery
      if (!from_recdPage && !to_recdPage) return // 没有 _recdPage参数标记 也不处理

      // if (!from_recdPage && to_recdPage) {
      //   //首次前进 或者 从其他路由返回过来，这个情况不触发
      //   return
      // }
      if (to_recdPage) {
        if (to_recdPage >= this.curRecdPage) {
          // console.log('前进')
          this.onRouterForward()
        } else {
          // console.log('后退')
          // console.log('后退11', this.curRecdPage, to_recdPage)
          this.onRouterBack()
        }
        this.curRecdPage = to_recdPage
      } else {
        // console.log('后退', this.curRecdPage)
        this.curRecdPage = 0
        this.onRouterBack()
      }
      // console.log('curRecdPage', this.curRecdPage)
    }
  },
  created() {
    const {_recdPage} = this.$route.query
    if (_recdPage) {
      this.curRecdPage = _recdPage
    }
  },
  methods: {
    /**
     * @description: 组件打开，需执行该方法
     * @param {*}
     * @return {*}
     */
    compPush() {
      let {query, name} = this.$route
      this.$router.push({
        query: {...query, _recdPage: Number(this.curRecdPage) + 1},
        name
      })
    },
    /**
     * @description: 返回事件，需重写方法
     * @param {*}
     * @return {*}
     */
    onRouterBack() {},
    /**
     * @description: 前进事件 按需重写
     * @param {*}
     * @return {*}
     */
    onRouterForward() {}
  }
  // beforeRouteLeave(to, from, next) {
  //   // 导航离开该组件的对应路由时调用
  //   // 可以访问组件实例 `this`
  //   // 退出模块接口，用于重置模块验证状态
  //   // console.log('beforeRouteLeave moduleVerifyMixins ')
  //   this.stopWatchRoute = true

  //   next()
  // },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.stopWatchRoute = false
  //   })
  // }
}
